import { create } from "zustand";
import { persist } from "zustand/middleware";

/** A preference, never an authorization decision. Available vessels come from the API. */
export const useVesselStore = create<{
  byUser: Record<string, string>;
  select: (userId: string, vesselId: string) => void;
}>()(persist((set) => ({
  byUser: {},
  select: (userId, vesselId) => set(state => ({ byUser: { ...state.byUser, [userId]: vesselId } })),
}), { name: "seaslot-vessel" }));
